import { movies } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';

export default function FeaturedMovies() {
  const featured = movies.filter((m) => m.featured);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-12">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-2">
              精选推荐
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              蜜桃电影编辑团队为你甄选的高分佳作
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-6" data-product-shop>
          {featured.map((movie) => (
            <MovieCard
              key={movie.id}
              id={movie.id}
              title={movie.title}
              titleEn={movie.titleEn}
              category={movie.category}
              year={movie.year}
              rating={movie.rating}
              posterImage={movie.posterImage}
            />
          ))}
        </div>
      </div>
    </section>
  );
}